<template>
    <div style="border-radius: 10px; background-color: white;" class="p-6 m-4">
        Document Verification Result
        <div class="flex items-start mt-2"
            style="background-color: #F0FDF4; border-radius: 10px; border:1px solid #B9F8CF; ">
            <img :src="require('@/assets/success-icon.svg')" alt="Info Icon"
                style="width: 40px; height: 40px; margin-top: 10px; margin-left: 10px;" />
            <div class="flex flex-col justify-center p-2">
                <p style="color: #008236;">✓ Document Verified Successfully</p>
                <p class="pb-4 text-xs font-light" style="color: #008236;">This document was generated by JPTT Connect
                    system and has not
                    been tampered with. All digital signatures have been verified.</p>
                <div :class="['flex items-start', isMobileScreen ? 'flex-col gap-4' : 'flex-row gap-6']">
                    <div>
                        <p class="text-xs" style="color: #606266;">
                            Document ID:
                        </p>
                        <p class="text-xs" style="color: #606266;">{{ documentId }}</p>
                    </div>
                    <div :class="[isMobileScreen ? '' : 'ml-3']">
                        <p class="text-xs" style="color: #606266;">
                            Generated Date:
                        </p>
                        <p class="text-xs" style="color: #606266;">{{ generateTime }}</p>
                    </div>
                </div>
            </div>
        </div>
        <div class="justify-center flex py-6">
            <div v-if="isMobileScreen" style="overflow-y: scroll; height: 350px; width: 100%;">
                <vue-pdf-embed  :source="certificateUrl" />
            </div>
            

            <iframe v-else :src="certificateUrl" width="100%" height="700px"
                title="Document Verification Result"></iframe>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
import { getServerUrl } from "@/utils/getServerUrl";
import { mapState } from 'vuex';
import VuePdfEmbed from 'vue-pdf-embed/dist/vue2-pdf-embed';

export default {
    components: {
        VuePdfEmbed
    },
    data() {
        return {
            certificateUrl: null,
            documentId: null,
            generateTime: null,
        };
    },
    computed: {
        ...mapState(["screenType"]),
        isMobileScreen() {
            return this.screenType?.isMobileScreen ?? true;
        }
    },
    created() {
        console.log('isMobile:', this.isMobile);
        const uploaded = this.$store.state.uploadedFile;
        if (!uploaded) {
            const urlParams = new URLSearchParams(window.location.search);
            const id = urlParams.get('id');
            const hash = urlParams.get('hash');
            this.documentId = id;
            this.generateTime = this.$route.query.generateTime;
            if (id && hash) {
                this.fetchCertificate(id, hash);
            } else {
                console.error('Missing id or hash in query parameters');
            }
        } else {
            this.certificateUrl = URL.createObjectURL(uploaded);
            this.documentId = this.$route.query.id;
            this.generateTime = this.$route.query.generateTime;
        }
    },
    beforeDestroy() {
        if (this.$store.state.uploadedFile) {
            this.$store.commit("setUploadedFile", null);
        }
    },
    methods: {
        async fetchCertificate(id, hash) {
            try {
                const response1 = await axios.get(`${getServerUrl()}/holdingCert/viewCert`, {
                    params: { id, hash },
                    responseType: 'blob',
                });
                const response2 = await axios.get(`${getServerUrl()}/holdingCert/detailsWithoutToken`, {
                    params: { id, hash },
                    responseType: 'json',
                });
                const result = response2.data?.data.holdingCert;
                this.certificateUrl = URL.createObjectURL(response1.data);
                this.documentId = id ?? "";
                this.generateTime = result?.approvedTime ?? ""
            } catch (error) {
                console.error('Error fetching certificate:', error);
            }
        },
    },
};
</script>

<style lang="scss" scoped></style>